/**
 * signOut.js — "Sign out" from the MHI user menu (2026-09-24).
 *
 * Production: clear this app's caches, then go straight to VarahiID's shared
 * signed-out page. That page ends the VarahiID session and pings every Varahi
 * product's logout, MHI's POST /varahi-mhi-access/logout included, so MHI's
 * session ends there. Going there FIRST, without awaiting our own logout, is
 * what Happen learned the hard way (AppNew.tsx, 2026-09-24): flipping the app to
 * "signed out" before navigating let the auto sign-in race the navigation.
 *
 * Dev (and a gate running in email-code mode): /id is not ours to call, so
 * POST the gate's logout ourselves and reload.
 */

import { ACCESS_BASE, APP_BASE, IS_DEV, SIGNED_OUT_URL } from './config.js';
import { clearAllCaches, AUTO_SSO_KEY } from './session.js';

export function appScopeUrl() {
  try { return new URL(APP_BASE, window.location.href).href; } catch { return undefined; }
}

export function clearAppCaches() {
  return clearAllCaches({
    cachesApi: typeof caches !== 'undefined' ? caches : undefined,
    serviceWorker: typeof navigator !== 'undefined' ? navigator.serviceWorker : undefined,
    scopeUrl: appScopeUrl(),
  });
}

export async function signOut(user) {
  await clearAppCaches();
  const viaVarahi = !IS_DEV && (!user || user.mode === 'varahiid');
  if (viaVarahi) {
    window.location.assign(`${SIGNED_OUT_URL}?continue=${encodeURIComponent(APP_BASE)}`);
    return;
  }
  try {
    await fetch(`${ACCESS_BASE}/logout`, {
      method: 'POST',
      credentials: 'include',
      headers: { accept: 'application/json' },
    });
  } catch { /* the reload below still asks the gate, which decides */ }
  // A deliberate sign-out is not an auto sign-in loop: let the next 401 go to login at once.
  try { sessionStorage.removeItem(AUTO_SSO_KEY); } catch { /* ignore */ }
  window.location.assign(APP_BASE);
}
